export default [
  {
    path: 'device-auth',
    name: 'DeviceAuth',
    meta: {
      isDynamic: true,
      id: '设备授权',
      inTab: true
    },
    component: () =>
      import(/* webpackChunkName: "DeviceAuth" */ '@/views/SystemSafe/DeviceAuth/DeviceAuth.vue')
  },
  {
    path: 'account-safe',
    name: 'AccountSafe',
    meta: {
      isDynamic: true,
      id: '账户安全',
      title: '账户安全',
      inTab: true
    },
    component: () =>
      import(/* webpackChunkName: "AccountSafe" */ '@/views/SystemSafe/AccountSafe/AccountSafe.vue')
  }
];
